import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Tiny offline indicator strip that appears at the top of the layout
 * when the browser is offline. Keeps users aware their changes will
 * sync once connectivity returns (important for African field missions).
 */
export default function OfflineIndicator() {
    const [offline, setOffline] = useState(() =>
        typeof navigator !== 'undefined' && navigator.onLine === false
    );

    useEffect(() => {
        const goOffline = () => setOffline(true);
        const goOnline = () => setOffline(false);
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
        };
    }, []);

    if (!offline) return null;
    return (
        <div
            data-testid="offline-indicator"
            className="fixed top-0 inset-x-0 z-50 bg-amber-600 text-white text-xs px-4 py-1.5 flex items-center justify-center gap-2 shadow-sm"
            role="status"
        >
            <WifiOff size={14} strokeWidth={1.8} />
            <span>Mode hors ligne — vos modifications seront synchronisées au retour du réseau.</span>
        </div>
    );
}
